<template>
  <h2 class="mb-5">会員登録ご希望の方</h2>
  <p class="text-center mt-3">会員登録には紹介者（スポンサー）が必要です。あらかじめ、紹介者（スポンサー）の方の会員番号をご用意ください。</p>
  <section class="login d-flex column_sp pt-5">
    <div class="box_2column">
      <div class="box-p-20 text-center">
        <p class="text-center">マナビス・メンバーズ・クラブ会員に登録すると、正規会員としてお得な価格で購入できたり、お友達を紹介したり、お知り合いに商品を販売できます。ショッピングポイントも付与されます。</p>
        <!-- CGI 呼び出し -->
        <router-link
          :to="{ path: '/serial', query: { ref: ref } }"
          class="btn d-inline-block mt-5"
          >メンバーズ会員として登録する</router-link
        >
      </div>
    </div>
    <div class="box_2column">
      <div class="box-p-20 text-center">
        <p>マナビス・ショッピング・クラブ会員に登録すると、ショッピングのみ楽しめる会員としてお得な価格で購入できます。ショッピングポイントも付与されます。ただし、商品の販売やお友達を紹介できません。</p>
        <router-link
          :to="{ path: '/mock/shopping/serial' }"
          class="btn d-inline-block mt-5"
          >ショッピング会員として登録する</router-link
        >
      </div>
    </div>
  </section>
  <section class="mt-5" style="margin-bottom: 80px;">
    <h2 class="mb-3">一般のお客様へ</h2>
    <div class="box-p-20 text-center">
      <!-- CGI 呼び出し -->
      <router-link
        :to="{ path: '/', query: { ref: ref } }"
        class="btn d-inline-block"
        >マナビス化粧品公式オンラインショップ</router-link
      >
    </div>
  </section>

  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>

<style scoped>

@media screen and (min-width: 1px) and (max-width: 1200px) {
  .login .box_2column:first-child > div {
    flex-direction: column !important;
  }
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .login .box_2column .box-p-20 {
    margin: 20px 0px;
  }
}
</style>

<script>
export default {

};
</script>
